import "core-js/modules/es6.object.define-properties";
import "core-js/modules/es7.object.get-own-property-descriptors";
import "core-js/modules/es6.array.for-each";
import "core-js/modules/es6.array.filter";
import "core-js/modules/es6.object.define-property";
import "core-js/modules/es6.object.assign";
import "core-js/modules/es6.symbol";
import "core-js/modules/es6.array.index-of";
import "core-js/modules/web.dom.iterable";
import "core-js/modules/es6.array.iterator";
import "core-js/modules/es6.object.to-string";
import "core-js/modules/es6.object.keys";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from 'react';
import { printDeprecationWarning, useDeprecatedComponentWarning } from '@nerdwallet/deprecate';
import ModalImpl from './modal-impl';
import useDeprecatedReactModalProps from './use-deprecated-react-modal-props'; // TODO future: remove this component on next major version bump

var BaseModal = function BaseModal(props) {
  /* eslint-disable react-hooks/rules-of-hooks */
  if (process.env.NODE_ENV !== 'production') {
    useDeprecatedComponentWarning({
      component: 'BaseModal',
      version: '8.10.0',
      migration: 'Use the Modal component from @nerdwallet/react-modal directly instead. BaseModal will be removed in next major version.'
    });
  }
  /* eslint-enable react-hooks/rules-of-hooks */


  var _useDeprecatedReactMo = useDeprecatedReactModalProps(props, 'BaseModal'),
      isCentered = _useDeprecatedReactMo.isCentered,
      isScrollable = _useDeprecatedReactMo.isScrollable,
      bodyOpenClassName = _useDeprecatedReactMo.bodyOpenClassName,
      titleElementId = _useDeprecatedReactMo.titleElementId,
      modalImplProps = _objectWithoutProperties(_useDeprecatedReactMo, ["isCentered", "isScrollable", "bodyOpenClassName", "titleElementId"]);

  return /*#__PURE__*/React.createElement(ModalImpl, _extends({
    isCentered: isCentered,
    isScrollable: isScrollable,
    bodyOpenClassName: bodyOpenClassName // spread remaining props directly onto ModalImpl

  }, modalImplProps));
}; // [DEPRECATED] only here for backwards-compatibility.  That was a passthrough to: http://reactcommunity.org/react-modal/accessibility/#app-element


BaseModal.setAppElement = function () {
  if (process.env.NODE_ENV !== 'production') {
    printDeprecationWarning({
      message: 'BaseModal.setAppElement has been deprecated and is now a NOOP. Please remove the callsites from your app. It will be removed in the next major version'
    });
  }
};

if (process.env.NODE_ENV !== 'production') {
  // eslint-disable-next-line global-require
  var PropTypes = require('prop-types');

  BaseModal.propTypes = _objectSpread(_objectSpread({}, ModalImpl.propTypes), {}, {
    /**
     * Applies styles to center the modal in the viewport
     */
    isCentered: PropTypes.bool,

    /**
     * Applies styles to make the modal scrollable when its height extends beyond the viewport
     */
    isScrollable: PropTypes.bool,

    /**
     * Additional ARIA attributes. This could be extended for more support.
     * @deprecated
     */
    aria: PropTypes.shape({
      labelledby: PropTypes.string
    }),

    /**
     * className to be applied to the document.body (must be a constant string).
     * See the [React Modal docs](http://reactcommunity.org/react-modal/styles/)
     * @deprecated
     */
    bodyOpenClassName: PropTypes.string,

    /**
     * Duration for modal visual animations.
     * @deprecated
     */
    closeTimeoutMS: PropTypes.number,

    /**
     * How the content container should be announced to screen readers.
     * @deprecated
     */
    contentLabel: PropTypes.string,

    /**
     * Will be run after the modal has opened.
     * @deprecated
     */
    onAfterOpen: PropTypes.func
  });
}

BaseModal.defaultProps = {
  // backwards-compatibility tweaks
  isCentered: false,
  isScrollable: true,
  // [DEPRECATED] - all props below this line should not be used.
  aria: undefined,
  bodyOpenClassName: null,
  contentLabel: undefined,
  onAfterOpen: undefined
};
export default BaseModal;